import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router';
import './upgrade.scss'
import CountdownTimer from '../../../veiws/Dashboard/sale/countDownTimer';

export const Upgrade = () => {
    const navigate = useNavigate();
    const logOut = () => {
        localStorage.removeItem("User_Data"); 
        localStorage.removeItem("login_timer_start"); 
        localStorage.setItem("LoggedIn", 'False');
        sessionStorage.removeItem('Products');

      window.location.reload(true)
      window.location.href = "/login";
    }
    const refresh = () => { 
        if (window.electron) { 
          window.location.reload(); // Use this for both browsers and Electron
        } else { 
          window.location.reload(true);
        }
      };
    return (
        <>
                <Box className="loggingOut">
                    <Button onClick={refresh}>Refresh</Button>
                </Box>
                <Box className='loggingOut' mt={1}>
                    <Button onClick={logOut}>Logout</Button>
                </Box>
                <Box className='loggingOut' mt={1}>
                    <CountdownTimer />
                </Box>

        <Box
            display={'flex'}
            alignItems="center"
            // gap={2}
            sx={{ m: 3, p: 3, bgcolor: `${'primary.light'}`, borderRadius: '8px' }}
        > 
                <Box>
                    <Typography variant="h6" mb={1}>Wasily Technology<br/>0703131865</Typography>
                    {/* <Button color="secondary" target="_blank" href="#" variant="contained" aria-label="logout" size="small">
                        Click Here
                    </Button> */}
                </Box>
                {/* <Box mt={3}>
                    <img alt="Remy Sharp" src='/images/logos/logo.png' width={80} />
                </Box> */} 
        </Box>
        </>
    );
};
